/**
 * Admin API client. Injects JWT, handles 401 by redirecting to login,
 * normalizes errors, and supports CSV/PDF binary responses.
 */
const BASE = process.env.REACT_APP_API_BASE || '';

function token() {
  return localStorage.getItem('admin_token') || '';
}

async function request(method, path, { body, headers = {}, raw = false, formData = false } = {}) {
  // Sprint C — admin site switcher header
  const adminSite = (typeof localStorage !== 'undefined' && localStorage.getItem('admin_active_site')) || '';
  const siteHeader = adminSite && adminSite !== 'default' ? { 'X-Admin-Site': adminSite } : {};
  const opts = { method, headers: { Authorization: `Bearer ${token()}`, ...siteHeader, ...headers } };
  if (formData) {
    opts.body = body;
  } else if (body !== undefined) {
    opts.headers['Content-Type'] = 'application/json';
    opts.body = JSON.stringify(body);
  }
  const res = await fetch(`${BASE}${path}`, opts);
  if (res.status === 401 || res.status === 403) {
    localStorage.removeItem('admin_token');
    if (typeof window !== 'undefined' && !window.location.pathname.includes('/admin/login')) {
      window.location.href = '/admin/login';
    }
    throw new Error('Not authenticated');
  }
  if (raw) return res;
  const ct = res.headers.get('content-type') || '';
  const data = ct.includes('json') ? await res.json() : await res.text();
  if (!res.ok) throw new Error((data && data.error) || `HTTP ${res.status}`);
  return data;
}

const api = {
  get:  (path, opts) => request('GET', path, opts),
  post: (path, body, opts = {}) => request('POST', path, { ...opts, body }),
  put:  (path, body, opts = {}) => request('PUT',  path, { ...opts, body }),
  patch: (path, body, opts = {}) => request('PATCH', path, { ...opts, body }),
  del:  (path, opts) => request('DELETE', path, opts),
  upload: (path, formData) => request('POST', path, { body: formData, formData: true }),
  raw:  (path, opts) => request('GET', path, { ...opts, raw: true }),
};

export default api;
